<template>
  <el-dialog title="Мессеж илгээх жагсаалт" v-model="customMessageDialog" width="70%">
    <el-row type="flex" justify="space-around" class="m-b-20 m-t-10">
      <el-col :span="7">
        <el-select v-model="messageDetail.progress_code" placeholder="Төлөв сонгоно уу">
          <el-option
            v-for="(item, index) in progressList"
            :key="index"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-date-picker
          v-model="messageDetail.startDate"
          type="datetime"
          placeholder="Эхлэх огноо"
        ></el-date-picker>
      </el-col>
      <el-col :span="4">
        <el-date-picker
          v-model="messageDetail.endDate"
          type="datetime"
          placeholder="Дуусах огноо"
        ></el-date-picker>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" class="w-100" @click="getPhones()">Хайх</el-button>
      </el-col>
    </el-row>

    <el-row v-if="loading">
      <el-col><el-spinner /> Өгөгдөл ачааллаж байна...</el-col>
    </el-row>

    <div v-if="queryResult.length > 0">
      <el-row gutter="20">
        <el-col :span="8">
          Илгээгдэх жишээ текст:
          <p>{{ selectedMessage.sms_text }}. {{ totalCountExampleText }} ширхэг ачаа. Tenger cargo</p>
          <div class="div_style mb-5"></div>
        </el-col>
        <el-col :span="8">
          <el-select
            class="w-100 m-l-5"
            v-model="selectedPhoneNumbers"
            multiple
            placeholder="Утасны дугаар сонгох"
            size="small"
            :value-key="'phone_number'"
          >
            <el-option
              v-for="(item, index) in queryResult"
              :key="index"
              :label="item.phone_number"
              :value="{ phone_number: item.phone_number, total_count: item.total_count }"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="4" class="mt-5">
          <el-button type="success" @click="submitForm()">Мессеж илгээх</el-button>
        </el-col>
      </el-row>

      <el-row class="mt-4" :gutter="20">
        <el-col
          v-for="(item, index) in queryResult"
          :key="index"
          class="m-t-10"
          :span="6"
        >
          <el-card class="m-r-5">
            <el-tag>{{ item.phone_number }}</el-tag>
            <p>Ачааны тоо: {{ item.total_count }}</p>
            <div v-for="(track, ti) in item.track_codes" :key="ti">
              <p>Трак код: {{ track.track_code }}</p>
              <p>Төлөвийн огноо: {{ track.progress_created_at.split('T')[0] }}</p>
              <p>Хоног: {{ track.days_diff }}</p>
              <hr class="m-t-5 m-b-5" />
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import services from '../services'
import { mapState, mapActions } from 'vuex'
import { ElMessage } from 'element-plus'

export default {
  name: 'CustomMessageDialog',
  props: {
    selectedMessage: { type: Object },
    query: { type: Array, default: () => [] }
  },
  data () {
    return {
      loading: false,
      progressList: [
        { id: 2, value: 110, label: 'Эрээн дах агуулхаас гарсан' },
        { id: 3, value: 120, label: 'Монгол дах салбар хүлээн авсан' },
        { id: 7, value: 150, label: 'Хэрэглэгч салбар дээр хадгалуулна' },
        { id: 9, value: 170, label: 'Ачаа салбар дээр үлдсэн' }
      ],
      messageDetail: {
        startDate: null,
        endDate: null,
        progress_code: null
      },
      queryResult: [],
      selectedPhoneNumbers: []
    }
  },
  computed: {
    ...mapState({
      visible: state => state.customMessageDialog
    }),
    customMessageDialog: {
      get () {
        return this.visible
      },
      set (val) {
        this.setCustomMessageDialog(val)
      }
    },
    totalCountExampleText () {
      // жишээ текстэнд аль нэг сонгогдсон total_count ашиглах (эхнийх)
      if (this.selectedPhoneNumbers.length) {
        return this.selectedPhoneNumbers[0].total_count
      }
      return ''
    }
  },
  watch: {
    customMessageDialog (newVal) {
      if (newVal && Array.isArray(this.query) && this.query.length) {
        // parent-аас өгөгдөл ирсэн тохиолдолд анх initialize
        this.queryResult = this.query.map(item => ({
          ...item,
          checked: true
        }))
        this.selectedPhoneNumbers = this.queryResult.map(item => ({
          phone_number: item.phone_number,
          total_count: item.total_count
        }))
      }
    },
    selectedPhoneNumbers (newVal) {
      const selectedSet = new Set(newVal.map(n => n.phone_number))
      this.queryResult.forEach(item => {
        item.checked = selectedSet.has(item.phone_number)
      })
    }
  },
  methods: {
    ...mapActions(['setCustomMessageDialog']),
    async getPhones () {
      this.loading = true
      const payload = { ...this.messageDetail }
      try {
        const response = await services.create('getPhoneList', payload)
        if (response && Array.isArray(response.data) && response.data.length) {
          this.queryResult = response.data.map(item => ({
            ...item,
            checked: true
          }))
          this.selectedPhoneNumbers = this.queryResult.map(item => ({
            phone_number: item.phone_number,
            total_count: item.total_count
          }))
        } else {
          ElMessage.error('Өгөгдөл олдсонгүй!')
        }
      } catch (error) {
        console.error('Error fetching data:', error)
        ElMessage.error(`Өгөгдөл ачаалахад алдаа гарлаа: ${error.message}`)
      } finally {
        this.loading = false
      }
    },
    async submitForm () {
      if (!this.selectedPhoneNumbers.length) {
        ElMessage.error('Та мессеж илгээх утасны дугаарыг сонгоно уу.')
        return
      }

      const payload = {
        sms_text_front: this.selectedMessage.sms_text,
        checkedPhoneNumbers: this.selectedPhoneNumbers // [{phone_number, total_count}, ...]
      }

      try {
        await services.create('sendCustomMessage', payload)
        ElMessage.success('Мессеж амжилттай илгээгдлээ!')
        this.customMessageDialog = false
      } catch (error) {
        console.error('API Request Error:', error.response ? error.response.data : error.message)
        ElMessage.error(error.message || 'Сүлжээний алдаа гарлаа.')
      }
    }
  }
}
</script>

<style scoped>
.div_style {
  background-color: green;
}
</style>
